module.exports = __webpack_public_path__ + "img/604A30_DC9065_212C14_AC9C92-256px.7a16d019.png";